import * as API from "middleware/api";

export const recoveryPassStep1 = (username, secondFactor, recaptchaResponse, recoveryType) =>
    API.executeAnonymous("/session.recoverPassword.step1", {
        _username: username,
        _secondFactor: secondFactor,
        _captcha: recaptchaResponse,
        recoveryType,
    });

export const recoveryPassStep2 = (code, recoveryType) =>
    API.executeAnonymous("/session.recoverPassword.step2", {
        _resetCode: code,
        recoveryType,
    });

export const recoveryPassStep3 = (newPassword, newPasswordConfirmation, resetCode, exchangeToken, recoveryType) => {
    let params = {};

    if (recoveryType === "password") {
        params = {
            _password: newPassword,
            _passwordConfirmation: newPasswordConfirmation,
        };
    }

    if (recoveryType === "username") {
        params = {
            _username: newPassword,
            _usernameConfirmation: newPasswordConfirmation,
        };
    }

    return API.executeWithExchangeToken(
        "/session.recoverPassword.step3",
        {
            ...params,
            _resetCode: resetCode,
            recoveryType,
        },
        exchangeToken,
    );
};

export const resetPassword = (password, newPassword, passwordconfirmation, exchangeToken) =>
    API.executeWithExchangeToken(
        "/session.resetPassword.step1",
        {
            _password: password,
            _newPassword: newPassword,
            _passwordConfirmation: passwordconfirmation,
        },
        exchangeToken,
    );
